import React from "react";
import ReactDOM from "react-dom";
import ExpressApi from './services/express-client';
import registerServiceWorker from "./registerServiceWorker";
import "./index.css";
import "semantic-ui-css/semantic.min.css";
import thunk from "redux-thunk";
import TimeEntry from "./containers/TimeEntry";
import WorkOrders from "./containers/WorkOrders";
import CreateEstimate from "./containers/CreateEstimate";
import Home from "./containers/Home";
import GeneralInfo from "./containers/GeneralInfo";
import SignUp from "./containers/NewUser";
import CustomerInfo from "./containers/CustInfo";
import Invoices from "./containers/Invoices";
import phone from "./containers/phone";
import TandM from "./containers/TandM";
import TMlist from "./containers/TMlist";
import HRAdmin from "./containers/HRAdmin";
import rootReducer from "./reducers";
import NotFound from "./components/shared-components/404";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import { Router, Route, hashHistory, IndexRoute } from "react-router";
import logger from "redux-logger";
import JobTracker from "./containers/JTAdmin";
import promise from "redux-promise-middleware";
import ManageEstimates from "./containers/ManageEstimate";
import { LoginService, LogoutService } from "./services/loginservice";
// import feathers from "feathers-client";
// import socketio from "feathers-socketio/client";
import EstimateReview from "./components/estimates/estimateview";
// import auth from "feathers-authentication-client";
import { modalhandler } from "./actions/modal-handler";
// import reactive from "feathers-reactive";
// import io from "socket.io-client";
import Reports from "./containers/Reports";
import axios from "axios";
import INVlist from "./components/pdf/invpdf";
import host from "./host.js";
import App from './App'
import moment from "moment";
const options = {
  header: "Authorization", // the default authorization header for REST
  path: "/authentication", // the server-side authentication service path
  jwtStrategy: "jwt", // the name of the JWT authentication strategy
  entity: "user", // the entity you are authenticating (ie. a users)
  service: "login", // the service to look up the entity
  cookie: "feathers-jwt", // the name of the cookie to parse the JWT from when cookies are enabled server side
  storageKey: "feathers-jwt", // the key to store the accessToken in localstorage or AsyncStorage on React Native
  storage: undefined // Passing a WebStorage-compatible object to enable automatic storage on the client.
};
const logoutTimer = (exp) => {
  var now = moment()
  var exp_time = moment(exp*1000)
  console.log("Expires", moment(exp*1000).format("MM/DD/YY"))
  console.log(`Expires in ${exp_time.diff(now)} ms`)
  setTimeout(() => {
    LogoutService();
  }, exp_time.diff(now));
}

export const store = createStore(
  rootReducer,
  applyMiddleware(promise(), logger, thunk)
);
console.log('testing')
export const app = new ExpressApi()
app
  .authenticate({
    strategy: "jwt",
    accessToken: window.localStorage.getItem("token")
  })
  .then(payload => {
    console.log("login Payload", payload);
    logoutTimer(payload.data.exp)
    LoginService(payload.data.userid);

  }).catch(err => {
    console.log("login Error", err);
    store.dispatch(modalhandler("login"));
  })

export const socket = app.io
export const timeservice = app.service("dailylaborentries");
export const wodservice = app.service("workorders");
export const assignedjobs = app.service("assign");
export const absentservice = app.service("expectedabsence");
export const restauth = app.api;
ReactDOM.render(
  <Provider store={store}>
    <Router history={hashHistory}>
      <Route path="/" component={App}>
        <IndexRoute component={Home} />
        <Route path="invoices/:tabindex" component={Invoices} />
        <Route path="tnms/:tabindex" component={TandM} />
        <Route path="cust-info/:tabindex" component={CustomerInfo} />
        <Route path="jobtracker/:wonum" component={JobTracker} />
        <Route path="time-entry" component={TimeEntry} />
        <Route path="new-user" component={SignUp} />
        <Route path="hr/:tabindex" component={HRAdmin} />
        <Route path="phone-book" component={phone} />
        <Route path="create-estimate" component={CreateEstimate} />
        <Route path="estimatereview/:estid" component={ManageEstimates} />
        <Route path="tmlist" component={TMlist} />
        <Route path="tmlist/:tmid" component={TMlist} />
        <Route path="invlist/:invid" component={INVlist} />
        <Route path="work-orders/:wonum" component={WorkOrders} />
        <Route path="general-info" component={GeneralInfo} />
        <Route path="reports/:tabindex" component={Reports} />
        <Route path="*" component={NotFound} />
      </Route>
      <Route path="/estimate/:estimatenumber" component={EstimateReview} />
    </Router>
  </Provider>,
  document.getElementById("root")
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js